export default {
  state: {
    dicData: new Map()
  },
  mutations: {
    setDicData(state, payload) {
      state.dicData.set(payload.api, payload.data)
    },
    clearDicData(state) {
      state.dicData.clear()
    }
  }
}
